import * as moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'moment',
    pure: false
})
export class MomentPipe implements PipeTransform {
    transform(value: string, output: string, input: string = null): string {
        if (input) { return moment(value, input).format(output); }
        return moment(value).format(output);
    }
}
